import {
  getAbandonedCheckout as publicGetAbandonedCheckout,
  deleteAbandonedCheckout as publicDeleteAbandonedCheckout,
  queryAbandonedCheckouts as publicQueryAbandonedCheckouts,
  searchAbandonedCheckouts as publicSearchAbandonedCheckouts,
  addAbandonedCheckoutActivity as publicAddAbandonedCheckoutActivity,
  redirectToCheckout as publicRedirectToCheckout,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { onAbandonedCheckoutCreated as publicOnAbandonedCheckoutCreated } from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';
import { onAbandonedCheckoutDeleted as publicOnAbandonedCheckoutDeleted } from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';
import { onAbandonedCheckoutRecovered as publicOnAbandonedCheckoutRecovered } from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';
import { onAbandonedCheckoutUpdated as publicOnAbandonedCheckoutUpdated } from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';

export const getAbandonedCheckout: MaybeContext<
  BuildRESTFunction<typeof publicGetAbandonedCheckout> &
    typeof publicGetAbandonedCheckout
> = /*#__PURE__*/ createRESTModule(publicGetAbandonedCheckout);
export const deleteAbandonedCheckout: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAbandonedCheckout> &
    typeof publicDeleteAbandonedCheckout
> = /*#__PURE__*/ createRESTModule(publicDeleteAbandonedCheckout);
export const queryAbandonedCheckouts: MaybeContext<
  BuildRESTFunction<typeof publicQueryAbandonedCheckouts> &
    typeof publicQueryAbandonedCheckouts
> = /*#__PURE__*/ createRESTModule(publicQueryAbandonedCheckouts);
export const searchAbandonedCheckouts: MaybeContext<
  BuildRESTFunction<typeof publicSearchAbandonedCheckouts> &
    typeof publicSearchAbandonedCheckouts
> = /*#__PURE__*/ createRESTModule(publicSearchAbandonedCheckouts);
/** @internal */
export const addAbandonedCheckoutActivity: MaybeContext<
  BuildRESTFunction<typeof publicAddAbandonedCheckoutActivity> &
    typeof publicAddAbandonedCheckoutActivity
> = /*#__PURE__*/ createRESTModule(publicAddAbandonedCheckoutActivity);
export const redirectToCheckout: MaybeContext<
  BuildRESTFunction<typeof publicRedirectToCheckout> &
    typeof publicRedirectToCheckout
> = /*#__PURE__*/ createRESTModule(publicRedirectToCheckout);
/**
 * Triggered when an abandoned checkout is created.
 */
export const onAbandonedCheckoutCreated: ReturnType<
  typeof createEventModule<typeof publicOnAbandonedCheckoutCreated>
> = createEventModule(publicOnAbandonedCheckoutCreated);
/**
 * Triggerred when an abandoned checkout is deleted.
 */
export const onAbandonedCheckoutDeleted: ReturnType<
  typeof createEventModule<typeof publicOnAbandonedCheckoutDeleted>
> = createEventModule(publicOnAbandonedCheckoutDeleted);
/**
 * Triggered when an abandoned checkout is recovered.
 */
export const onAbandonedCheckoutRecovered: ReturnType<
  typeof createEventModule<typeof publicOnAbandonedCheckoutRecovered>
> = createEventModule(publicOnAbandonedCheckoutRecovered);
/**
 * Triggered when an abandoned checkout is updated.
 */
export const onAbandonedCheckoutUpdated: ReturnType<
  typeof createEventModule<typeof publicOnAbandonedCheckoutUpdated>
> = createEventModule(publicOnAbandonedCheckoutUpdated);

export {
  ActivityType,
  Status,
  VatType,
  Identity,
  SortOrder,
  CommonSortOrder,
  Mode,
  WebhookIdentityType,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
export {
  AbandonedCheckout,
  V1BuyerInfo,
  V1BuyerInfoIdOneOf,
  FullAddressContactDetails,
  VatId,
  MultiCurrencyPrice,
  Activity,
  CartAbandonedEvent,
  BuyerInfo,
  Totals,
  CartRecoveredEvent,
  AbandonedCheckoutRecovered,
  GetAbandonedCheckoutRequest,
  GetAbandonedCheckoutResponse,
  DeleteAbandonedCheckoutRequest,
  DeleteAbandonedCheckoutResponse,
  QueryAbandonedCheckoutsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryAbandonedCheckoutsResponse,
  PagingMetadataV2,
  Cursors,
  SearchAbandonedCheckoutsRequest,
  Search,
  SearchPagingMethodOneOf,
  CommonSorting,
  SearchDetails,
  CommonPaging,
  CommonCursorPaging,
  SearchAbandonedCheckoutsResponse,
  CommonPagingMetadataV2,
  CommonCursors,
  AddAbandonedCheckoutActivityRequest,
  AddAbandonedCheckoutActivityResponse,
  Task,
  TaskKey,
  TaskAction,
  TaskActionActionOneOf,
  Complete,
  Cancel,
  Reschedule,
  RedirectToCheckoutRequest,
  RawHttpResponse,
  HeadersEntry,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AbandonedCheckoutNonNullableFields,
  GetAbandonedCheckoutResponseNonNullableFields,
  QueryAbandonedCheckoutsResponseNonNullableFields,
  SearchAbandonedCheckoutsResponseNonNullableFields,
  AddAbandonedCheckoutActivityResponseNonNullableFields,
  RawHttpResponseNonNullableFields,
  BaseEventMetadata,
  EventMetadata,
  AbandonedCheckoutCreatedEnvelope,
  AbandonedCheckoutDeletedEnvelope,
  AbandonedCheckoutRecoveredEnvelope,
  AbandonedCheckoutUpdatedEnvelope,
  AbandonedCheckoutsQueryResult,
  AbandonedCheckoutsQueryBuilder,
  SearchAbandonedCheckoutsOptions,
  AddAbandonedCheckoutActivityOptions,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
